var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconicButton',{attrs:{"text":_vm.fullScreenProps.text,"icon":_vm.fullScreenProps.icon},on:{"click":function($event){return _vm.$emit('input', !_vm.isExpanded)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }